import React, { Fragment,Component } from 'react';
import logo from '../images/toolbox_banner_small.png';
import houseof from '../images/HouseOf_medium.png';

class build extends Component {
    render() {
        return (
            <Fragment>
                <div className='img-container'>
                    <img src={logo} alt="toolbox"/>
                </div>
                <div className='img-container'>
                    <img src={houseof} alt="house"/>
                </div>
                <div className="body-container">
                    <br/>
                    <div className="CenteredTitle">Build with Us</div>
                    <br/>
                    <div className="text-center">
                        There is strength in numbers. Share our links and tools with other developers.  Strengthen our development community by promoting testing and what we stand for!
                        Do you have a project you’re working on and you’d like to share it with others?
                        Interested in posting a link on our site? 
                        Reach out to us and share your ideas and thoughts! 
                        We are always looking for new people to collaborate with. 
                        We look forward to hearing from you!
                    <br/><a href="mailto:mytestingtools.com@gmail.com?subject=Build with Us" className="">Click here to contact us now</a>

                    </div>
                </div>
            </Fragment>
        )
    }
}

export default build



// WEBPACK FOOTER //
// ./src/components/layout/build.js